import { PdfBarcodeComponent } from '../../PdfComponent';
import React from 'react';
import { DropdownSearchSelect } from '../../../../components/Dropdown';
import { usePdfTemplateContext } from '../../PdfTemplateEditorContext';
import PdfTemplateComponentDefault from '../properties/PdfTemplateComponentDefault';
import { PdfFieldResolving } from '../../data/PdfFieldResolving';
import { PdfDataKey, PdfFieldEntity } from '../../data/PdfDataKey';
import { BarcodeExportConfigurationEntry } from '../../../../../types/barcode_export_configuration';

interface PdfTemplateBarcodeComponentPropertiesProps {
  component: PdfBarcodeComponent;
}

export default function PdfTemplateBarcodeComponentProperties<T>({
  component,
}: PdfTemplateBarcodeComponentPropertiesProps) {
  const { dataKeys, updateComponent, data, settings } = usePdfTemplateContext<T>();

  return (
    <div className='grid gap-2'>
      <PdfTemplateComponentDefault component={component} />

      {settings.barcodeExportEntries.length ? (
        <>
          <p className='section-title mt-2'>Barcode</p>
          <DropdownSearchSelect<BarcodeExportConfigurationEntry>
            placeholder={'Select barcode entry'}
            textBuilder={entry => entry.field}
            items={settings.barcodeExportEntries}
            onSelect={entry =>
              updateComponent(component.id, {
                entry,
                key: { entityType: PdfFieldEntity.barcode, customFieldId: entry?.id || '' },
              })
            }
            value={component.entry}
            label={'Barcode entry'}
          />
        </>
      ) : (
        <>
          <p className='section-title mt-2'>Content</p>
          <DropdownSearchSelect<PdfDataKey<any>>
            placeholder={'Select field to populate'}
            items={dataKeys}
            textBuilder={key => PdfFieldResolving.getLabel(key, data)}
            onSelect={key => updateComponent(component.id, { key })}
            value={component.key}
            label={'Field to populate'}
          />
        </>
      )}
    </div>
  );
}
